export const routes = [{
    path: '/municipioEixo',
    component: () =>
        import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'municipioEixos.list',
    meta: {
        requiresAuth: true
    }
}]
